export const timelineData = {
    periods: [
        {
            id: 1,
            yearsOne: '1985',
            yearsTwo: '1991',
            title: 'Распад СССР и становление',
            events: [
                {
                    id: 1,
                    year: '1985',
                    description: 'Начало Перестройки - курс на ускорение социально-экономического развития страны, провозглашенный Михаилом Горбачевым'
                },
                {
                    id: 2,
                    year: '1986',
                    description: 'Авария на Чернобыльской АЭС - крупнейшая катастрофа в истории атомной энергетики, повлиявшая на экологическую политику worldwide'
                },
                {
                    id: 3,
                    year: '1989',
                    description: 'Вывод советских войск из Афганистана - завершение девятилетнего военного конфликта, унесшего жизни тысяч солдат'
                },
                {
                    id: 4,
                    year: '1990',
                    description: 'Принятие Декларации о государственном суверенитете России - первый шаг к созданию независимого российского государства'
                },
                {
                    id: 5,
                    year: '1991',
                    description: 'Августовский путч и Беловежские соглашения - события, приведшие к окончательному распаду Советского Союза'
                }
            ]
        },
        {
            id: 2,
            yearsOne: '1992',
            yearsTwo: '1999',
            title: 'Экономические реформы и кризис',
            events: [
                {
                    id: 6,
                    year: '1992',
                    description: 'Либерализация цен и начало ваучерной приватизации - переход от плановой к рыночной экономике, сопровождавшийся гиперинфляцией'
                },
                {
                    id: 7,
                    year: '1993',
                    description: 'Конституционный кризис и штурм Белого дома - противостояние между президентом Ельциным и Верховным Советом'
                },
                {
                    id: 8,
                    year: '1994',
                    description: 'Начало первой чеченской войны - вооруженный конфликт за независимость Чеченской Республики Ичкерия'
                },
                {
                    id: 9,
                    year: '1996',
                    description: 'Президентские выборы и операция "Честная игра" - кампания, определившая политическое будуние России на годы вперед'
                },
                {
                    id: 10,
                    year: '1998',
                    description: 'Дефолт и финансовый кризис - обвал рубля, банковский кризис и массовые неплатежи по государственным обязательствам'
                }
            ]
        },
        {
            id: 3,
            yearsOne: '2000',
            yearsTwo: '2007',
            title: 'Стабилизация и рост',
            events: [
                {
                    id: 11,
                    year: '2000',
                    description: 'Избрание Владимира Путина президентом - начало политики укрепления вертикали власти и борьбы с олигархами'
                },
                {
                    id: 12,
                    year: '2003',
                    description: 'Арест Михаила Ходорковского - переломный момент в отношениях между государством и крупным бизнесом'
                },
                {
                    id: 13,
                    year: '2004',
                    description: 'Теракт в Беслане - трагедия, приведшая к отмене прямых выборов губернаторов и другим изменениям в политической системе'
                },
                {
                    id: 14,
                    year: '2006',
                    description: 'Запуск проекта "Национальные проекты" - масштабные программы в области здравоохранения, образования и сельского хозяйства'
                },
                {
                    id: 15,
                    year: '2007',
                    description: 'Выступление в Мюнхене - знаковая речь Владимира Путина, обозначившая новые принципы внешней политики России'
                }
            ]
        },
        {
            id: 4,
            yearsOne: '2008',
            yearsTwo: '2013',
            title: 'Кризис и модернизация',
            events: [
                {
                    id: 16,
                    year: '2008',
                    description: 'Пятидневная война с Грузией - вооруженный конфликт вокруг Южной Осетии, изменивший геополитическую ситуацию в регионе'
                },
                {
                    id: 17,
                    year: '2009',
                    description: 'Мировой экономический кризис в России - падение ВВП на 7,9%, массовые сокращения и антикризисные меры правительства'
                },
                {
                    id: 18,
                    year: '2010',
                    description: 'Аномальная жара и лесные пожары - природная катастрофа, унесшая жизни тысяч людей и нанесшая огромный экономический ущерб'
                },
                {
                    id: 19,
                    year: '2011',
                    description: 'Протесты на Болотной площади - массовые выступления против фальсификаций на парламентских выборах'
                },
                {
                    id: 20,
                    year: '2013',
                    description: 'Зимняя Олимпиада в Сочи - масштабный инфраструктурный проект, ставший символом возрождения России'
                }
            ]
        },
        {
            id: 5,
            yearsOne: '2014',
            yearsTwo: '2019',
            title: 'Геополитические вызовы',
            events: [
                {
                    id: 21,
                    year: '2014',
                    description: 'Крымская весна и воссоединение с Крымом - историческое событие, изменившее карту Европы и вызвавшее международные санкции'
                },
                {
                    id: 22,
                    year: '2015',
                    description: 'Военная операция в Сирии - участие российских ВКС в борьбе с терроризмом на стороне правительственных войск'
                },
                {
                    id: 23,
                    year: '2016',
                    description: 'Выборы в Государственную Думу - победа "Единой России" и формирование нового политического ландшафта'
                },
                {
                    id: 24,
                    year: '2018',
                    description: 'Чемпионат мира по футболу - масштабное спортивное событие, продемонстрировавшее гостеприимство России'
                },
                {
                    id: 25,
                    year: '2019',
                    description: 'Национальные проекты и майские указы - новые социально-экономические инициативы по развитию страны до 2024 года'
                }
            ]
        },
        {
            id: 6,
            yearsOne: '2020',
            yearsTwo: '2024',
            title: 'Пандемия и новые реалии',
            events: [
                {
                    id: 26,
                    year: '2020',
                    description: 'Пандемия COVID-19 и общероссийский локдаун - беспрецедентные меры по борьбе с коронавирусом и поддержке экономики'
                },
                {
                    id: 27,
                    year: '2021',
                    description: 'Разработка вакцин "Спутник V" и "КовиВак" - российская фармацевтика в условиях глобальной пандемии'
                },
                {
                    id: 28,
                    year: '2022',
                    description: 'Специальная военная операция на Украине - начало масштабного военного конфликта и ужесточение международных санкций'
                },
                {
                    id: 29,
                    year: '2023',
                    description: 'Мятеж ЧВК "Вагнер" и консолидация власти - внутренние политические вызовы и их преодоление'
                },
                {
                    id: 30,
                    year: '2024',
                    description: 'Президентские выборы и инаугурация - новый шестилетний срок Владимира Путина и формирование нового правительства'
                }
            ]
        }
    ]
};
